import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MyLoadsTable, Quote } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-post-load',
	templateUrl: './post-load.component.html',
	styleUrls: ['./post-load.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PostLoadComponent implements OnInit {
	@Input() isDuplicateLoad: boolean = false;
	@Input() isEditQuote: boolean = false;
	@Input() load: MyLoadsTable = null;
	@Input() quote: Quote = null;
	@Output() updatedData = new EventEmitter<Quote>();

	constructor(public dialog: MatDialog, public utilService: UtilService) {}

	ngOnInit() {}

	openPostLoadDialog(): void {
		const dialogRef = this.dialog.open(PostLoadDialog, {
			width: '950px',
			data: {
				isDuplicateLoad: this.isDuplicateLoad,
				isEditQuote: this.isEditQuote,
				quote: this.quote,
				data: this.load,
			},
			disableClose: true,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				this.updatedData.emit(result);
			}
		});
	}
}

@Component({
	selector: 'app-post-load-dialog',
	templateUrl: 'modal.html',
})
export class PostLoadDialog implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<PostLoadDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
